import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from './ErrorMessage';
import Tooltip from '../Tooltip';
import Label from '../Label';

// id is a required prop of tooltip, so return something truthy.
const getTooltipId = (id, htmlFor) => {
  if (id) {
    return `${id}Tooltip`;
  }
  if (htmlFor) {
    return `${htmlFor}Tooltip`;
  }
  return 'formGroupTooltip';
};

export const FormGroup = props => {
  const { id, htmlFor, text, tooltipText, labelClassName, children, error, className, errorClassName } = props;

  const tooltip = tooltipText ? <Tooltip hoverText={tooltipText} tooltipText='' id={getTooltipId(id, htmlFor)} /> : null;

  return (
    <div id={id} className={error ? `pxl-form-group pxl-has-error ${className}` : `pxl-form-group ${className}`}>
      <Label htmlFor={htmlFor} text={text} className={labelClassName}>
        {tooltip}
      </Label>
      {children}
      <ErrorMessage error={error} className={errorClassName} />
    </div>
  );
};

FormGroup.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  errorClassName: PropTypes.string,
  htmlFor: PropTypes.string,
  id: PropTypes.string,
  labelClassName: PropTypes.string,
  text: PropTypes.string,
  tooltipText: PropTypes.string
};

FormGroup.defaultProps = {
  className: '',
  errorClassName: '',
  id: '',
  labelClassName: ''
};

export default FormGroup;
